import React from "react";
import { Helmet } from "react-helmet-async";
import { Box, Container, Paper, Typography } from "@mui/material";
import { AccountBalance as BankIcon } from "@mui/icons-material";
import useAuth from "../../../../hooks/useAuth";

export const SuperAdminOrComingSoon: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { currentUser } = useAuth();
  return currentUser?.isSuperAdmin ? <>{children}</> : <ComingSoon />;
};

const ComingSoon: React.FC = () => (
  <>
    <Helmet title="Pankkiyhteys – Tulossa pian" />
    <Container maxWidth="md" sx={{ mt: 6 }}>
      <Paper sx={{ p: 6, textAlign: "center" }}>
        <Box sx={{ mb: 2 }}>
          <BankIcon sx={{ fontSize: 64, color: "text.secondary" }} />
        </Box>
        <Typography variant="h3" gutterBottom>
          Tulossa pian
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Pankkiyhteys ja tiliotteiden automaattinen täsmäytys ovat vielä
          kehityksen alla. Otamme ominaisuuden käyttöön, kun yhteydet pankkeihin
          on viimeistelty.
        </Typography>
      </Paper>
    </Container>
  </>
);

export default ComingSoon;
